import { render, staticRenderFns } from "./product.vue?vue&type=template&id=2afca24f&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
import style0 from "./product.vue?vue&type=style&index=0&id=2afca24f&prod&scoped=true&lang=css"
import style1 from "./product.vue?vue&type=style&index=1&id=2afca24f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afca24f",
  null
  
)

export default component.exports